import config from "config";

export const BASE_URL = config.app.BACKEND_URL;

// Auth Urls
export const LOGIN_URL = "/auth/api-token-auth/";
export const GOOGLE_REDIRECT = "/auth/sign-in";
export const GOOGLE_LOGIN_URL = "/auth/google-login/"

// Contracts Urls
export const GET_CLAUSES_URL = "/contracts/clauses/"
export const CONTRACTS_URL = "/contracts/contracts/"
export const MY_CONTRACT_URL = "/contracts/contracts/my_contract/"

// Employees Urls
export const GET_ALL_EMPLOYEES = "/employees/employees/";
export const EMPLOYEES_URL = "/employees/employees/";
export const GET_ACTIVE_OR_RECENTLY_LEFT_EMPLOYEES = `${EMPLOYEES_URL}get_active_or_recently_left_employees`;
export const EMPLOYEE_PROFILE_URL = "employees/profile/"
export const CREATE_EMPLOYEE_BY_USER = "/employees/employees/create_by_user/";
export const UPDATE_EMPLOYEE_BY_USER = "/employees/employees/update_by_user/";
export const GET_ALL_BANKS = "/employees/banks/";
// Dependents Urls
export const DEPENDENTS_BULK_CREATE = "/employees/dependants/bulk_create/";

// Employees Leaves Urls
export const LEAVE_INFO = "/leaves/leaveinfo/";
export const GET_EMPLOYEE_LEAVES_INFO = "/leaves/leaveinfo/employee/";
export const REMAINING_LEAVES_TYPES_INFO = "/leaves/leaveinfo/remaining/employee/";

export const GET_EMPLOYEE_LEAVES_DETAILS = "/leaves/leavedetails/employee/";
export const GET_SUBORDINATES_LEAVES = "/leaves/leavedetails/subordinates_leaves/";
export const GET_SUBORDINATE_LEAVE = "/leaves/leavedetails/subordinate_leave_by_id/";

export const LEAVE_DETAILS = "/leaves/leavedetails/";
export const TEAM_LEAVE_CALENDAR = "/leaves/leavedetails/team_leave_calendar/";
export const REQUEST_LEAVE = "/leaves/leavedetails/request/";
export const HR_ADD_LEAVE = "/leaves/leavedetails/hr-add/";
export const HR_DELETE_LEAVE = "/leaves/leavedetails/hr-delete/";
export const GET_ALL_LEAVES_DETAILS = "/leaves/leavedetails/";
export const GET_EMPLOYEE_LEAVE_TYPES = "/leaves/leaveinfo/assignment_matrix/";

export const LEAVE_TYPE = "/leaves/leavetype/";
export const ALL_LEAVES_INFO = "/leaves/allleaves";
// api/urls.ts


// PAYROLL URLS
export const PAYSLIP_NON_AUTO_ITEM_TYPES_URL = "/payroll/non-auto-line-item-types/";
export const PAYROLL_URL = "/payroll/";
export const PAYSLIP_URL = "/payroll/payslip/";
export const PAYSLIP_PDF_URL =  "/payroll/generate-pdf/"
export const PAYSLIP_BATCH_URL = "/payroll/batch-payslips/";
export const PAYSLIPS_EMPLOYEE_URL = "/payroll/employee/";
export const PAYSLIP_LINE_ITEM_TYPES_URL = "/payroll/payslip-item-type/";
export const MY_PAYSLIPS_URL = "/payroll/my-payslips/";
export const PAYROLL_REPORTS_URL = "/payroll/reports/generate_reports/";
export const PAYROLL_TAX_REPORT_URL = "/payroll/reports/generate_tax_report/";

// Appraisalsl Urls
export const GET_ASSIGNED_FORMS_FOR_USER = "/appraisals/appraisal_forms/assigned-forms-for-user/";
export const GET_COMPLETED_FORMS_FOR_USER = "/appraisals/appraisal_forms/completed-forms-for-user/";
export const GET_APPRAISAL_FORM = "/appraisals/appraisal_forms/";
export const POST_APPRAISAL_FORM = "/appraisals/appraisal_forms/submit/";
export const QUESTIONS_URL = '/appraisals/questions/';
export const APPRAISAL_RESPONSES_URL = '/appraisals/appraisal_responses/';
export const ASSIGN_FORMS_URL = "/appraisals/appraisal_forms/assign/";
export const UPDATE_FORM_URL = "/appraisals/appraisal_forms/";
export const DELETE_APPRAISAL_FORM_URL = "/appraisals/appraisal_forms/";
export const SET_FORM_STATUS_URL = "/appraisals/appraisal_forms/";
export const GET_ACTIVE_APPRAISAL_FORMS_URL = "/appraisals/appraisal_forms/active/";
export const GET_INACTIVE_APPRAISAL_FORMS_URL = "/appraisals/appraisal_forms/inactive/";

// Template Builder Urls
export const TEMPLATES_URL = "/tempalte-builder/templates/";
export const QUESTIONS_TEMPLATE_URL = "/tempalte-builder/questions/";

// Appraisal Cycle Urls
export const APPRAISAL_CYCLES_URL = "/appraisal-cycle/cycles/";
export const PEER_REVIEW_NOMINATIONS_URL = "/appraisal-cycle/cycles/";
export const PEER_REVIEW_NOMINATION_DETAIL_URL = "/appraisal-cycle/cycles/";
export const LOCK_UNLOCK_CYCLE_URL = "/appraisal-cycle/cycles/";
export const GENERATE_CYCLE_REPORT_URL = "/appraisal-cycle/cycles/";
export const VIEW_CYCLE_REPORT_URL = "/appraisal-cycle/cycles/";

// Appraisal Response Urls
export const APPRAISAL_RESPONSE_CYCLES_AVAILABLE_URL = "/appraisal-response/cycles/available/";
export const APPRAISAL_RESPONSE_CYCLE_DETAIL_URL = "/appraisal-response/cycles/";
export const APPRAISAL_RESPONSE_CYCLE_EMPLOYEES_STATUS_URL = "/appraisal-response/cycles/";
export const APPRAISAL_RESPONSE_EMPLOYEE_RESPONSE_URL = "/appraisal-response/cycles/";
export const APPRAISAL_RESPONSE_URL = "/appraisal-response/";

// Employee Appraisal Response Urls
export const EMPLOYEE_SELF_REVIEW_CYCLES_URL = "/appraisal-response/employee/self-review/cycles/";
export const EMPLOYEE_PEER_REVIEW_CYCLES_URL = "/appraisal-response/employee/peer-review/cycles/";
export const EMPLOYEE_CYCLE_DETAIL_URL = "/appraisal-response/employee/cycles/";
export const EMPLOYEE_PEER_REVIEW_EMPLOYEES_URL = "/appraisal-response/employee/cycles/";
export const EMPLOYEE_SELF_RESPONSE_URL = "/appraisal-response/employee/cycles/";
export const EMPLOYEE_PEER_RESPONSE_URL = "/appraisal-response/employee/cycles/";
export const EMPLOYEE_APPRAISAL_RESPONSES_URL = "/appraisal-response/employee/responses/";
export const EMPLOYEE_APPRAISAL_RESPONSE_DETAIL_URL = "/appraisal-response/employee/responses/";
export const EMPLOYEE_SUBMIT_RESPONSE_URL = "/appraisal-response/employee/responses/";

export const MANAGER_AVAILABLE_CYCLES_URL = "/appraisal-response/manager/cycles/available/";
export const MANAGER_CYCLE_DETAIL_URL = "/appraisal-response/manager/cycles/";
export const MANAGER_CYCLE_EMPLOYEES_STATUS_URL = "/appraisal-response/manager/cycles/";
export const MANAGER_EMPLOYEE_RESPONSE_URL = "/appraisal-response/manager/cycles/";
export const MANAGER_TEAM_MEMBER_RESPONSES_URL = "/appraisal-response/manager/cycles/";
export const MANAGER_APPRAISAL_RESPONSES_URL = "/appraisal-response/manager/responses/";
export const MANAGER_APPRAISAL_RESPONSE_DETAIL_URL = "/appraisal-response/manager/responses/";


// Careers Urls
export const GET_ALL_JOB_OPENINGS = "/careers/job-openings/"
export const GET_ALL_APPLICANTS = "/careers/applicants/"
export const GET_ALL_JOB_APPLICATIONS = "/careers/job-applications/"
export const GET_STATUS_CHOICES = "careers/job-applications/status-choices/"
export const GET_SKILLS = "/careers/skills/"
export const POST_SKILLS = "/careers/skills/"
export const DEPARTMENTS_URL = "/careers/departments/"

// Policy Urls
export const POLICIES_URL = "/policy/policies/";
export const CREATE_POLICY_URL = "/policy/policies/create/";

//Bulletin Urls
export const GET_ALL_HOLIDAYS = "/bulletin/holidays/"
export const GET_ALL_ANNOUNCEMENTS = "/bulletin/announcements/"

// Employee Utilization URLs
export const GET_WORK_CATEGORIES = "/employee-utilization/work-categories/";
export const GET_EMPLOYEE_SUBORDINATES = "/employee-utilization/employees/";
export const GET_ALL_EMPLOYEES_FOR_REVIEW_ASSIGNMENT = "/employee-utilization/all-employees/"
export const CREATE_EMPLOYEE_UTILIZATION = "/employee-utilization/utilizations/create/";

// Manager specific endpoints
export const MANAGER_EMPLOYEE_UTILIZATIONS = "/employee-utilization/manager-utilizations/";
export const APPROVE_UTILIZATION = "/employee-utilization/utilizations/";
export const BULK_APPROVE_UTILIZATIONS = "/employee-utilization/utilizations/bulk-approve/";
export const CREATE_MANAGER_UTILIZATION_BATCH = "/employee-utilization/create-batch/";
export const CREATE_MANAGER_WORK_CATEGORY = "/employee-utilization/create-work-category/";
export const GET_ALL_MANAGERS = "/employee-utilization/all-manager/";

// Employee specific endpoints
export const GET_MY_UTILIZATIONS = "/employee-utilization/my-utilizations/";

//Organization structre
export const GET_ORGANIZATION_STRUCTURE = "/organization-structure/employees/";
export const GET_ALL_DEPARTMENTS = "/organization-structure/departments/";
export const CREATE_DEPARTMENT = "/organization-structure/departments/";
export const GET_ENHANCED_DEPARTMENTS = "/organization-structure/enhanced-departments/";
export const GET_DEPARTMENT_WITH_LEVELS = "/organization-structure/enhanced-departments/with_levels/";
export const GET_ALL_LEVELS= "/organization-structure/levels/";
export const CREATE_DEPARTMENT_LEVELS= "/organization-structure/department-levels/";
export const GET_DEPARTMENT_LEVELS= "/organization-structure/department-levels/";
export const GET_ALL_TITLES= "/organization-structure/titles/";
export const CREATE_LEVELS= "/organization-structure/levels/";

export const GET_ORGANIZATION_VIEW= "/organization-structure/organization/overview/";
export const GET_ORGANIZATION_TREE= "/organization-structure/organization/tree/";
export const GET_DEPARTMENT_ORGANIZATION_STRUCTURE= "/organization-structure/organization/structure/";

//Notifications
export const GET_ALL_NOTIFICATIONS = "/notifications/"
export const GET_UNREAD_NOTIFICATIONS = "notifications/unread/"

//Test
export const TEST_SESSIONS = "/first_test/test-sessions/";
export const QUESTIONS = "/first_test/questions/";

// Video Test
export const VIDEO_TEST_SESSIONS = "/video-test/video-test-sessions/";
export const VIDEO_TEST_QUESTIONS = "/video-test/questions/";

// General Questionnaire
export const GENERAL_QUESTIONNAIRE_SESSIONS = "/general-questionnaire/questionnaire-sessions/";
export const GENERAL_QUESTIONNAIRE_QUESTIONS = "/general-questionnaire/questions/";

// Client Management
export const CLIENTS_URL = "/clients/clients/";
export const CLIENT_USERS_URL = "/clients/client-users/";
export const EMPLOYEE_CLIENT_ASSIGNMENTS_URL = "/clients/employee-assignments/";
export const CLIENT_USER_LEAVES_URL = "/clients/client-user-leaves/";

// Client Users
// Users / Auth
export const ALL_SYSTEM_USERS_URL = "/auth/users/";

// 1. For the Admin to Configure Schedules
// We will append {id}/schedule/ to this in the helper
export const CLIENT_ASSIGNMENT_BASE_URL = "/clients/assignments/";

// 2. For the Client Portal (The User Interface)
export const CLIENT_PORTAL_PENDING_REVIEWS_URL = "/appraisal-response/client/pending/";
export const CLIENT_PORTAL_SUBMIT_REVIEW_URL = "/appraisal-response/client/submit/"; // Appends {id}/
// Appraisal Cycle Urls (Add these new ones)
export const CLIENT_ASSIGNMENT_LIST_CREATE_URL = (cycleId: number) => `/appraisal-cycle/cycles/${cycleId}/client-assignments/`;
export const CLIENT_ASSIGNMENT_BULK_SYNC_URL = (cycleId: number) => `/appraisal-cycle/cycles/${cycleId}/client-assignments/bulk-sync/`;

// New URL for the Client Portal to fetch only their assigned cycles
export const CLIENT_ASSIGNED_CYCLES_URL = "/appraisal-cycle/cycles/client-assigned/";
